import PropTypes from 'prop-types';

// import TableIsAdvertisingFilter from 'components/TableIsAdvertisingFilter';
import TableIsNewFilter from 'components/TableIsNewFilter';

const TableHeader = ({ children, isNewAdvertisingShown }) => (
  <div className="flex-nowrap touch-auto overflow-x-auto lg:overflow-visible flex items-center px-4">
    {children}
    {isNewAdvertisingShown && (
      <div className="flex gap-4 pl-3 border-l border-gray-200">
        <TableIsNewFilter />
        {/*<TableIsAdvertisingFilter />*/}
      </div>
    )}
  </div>
);
TableHeader.defaultProps = {
  isNewAdvertisingShown: true,
};
TableHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  isNewAdvertisingShown: PropTypes.bool,
};
export default TableHeader;
